import React, { Component } from 'react';
import PropTypes from "prop-types";
import FormControl from "../-FormControl";
import { toast } from '@platform/api';
import { isFunction } from 'util';
import { getMultiLang, getDataFormatFromCache } from '@platform/api';
import { formatNumber } from './format';
import { NEED_SELECTION_ITEMS } from '../-FormControl/constants';
import { getSysFieldid } from '@platform/api';
import Calculator from '../Calculator';
import Big from "big.js";

const propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
};

const defaultProps = {
    verify: true,
    scale: 0,
    disabled: false,
    value: '',
};

function ncRounding(value, scale) {
    // 如果没有精度，不需要处理四舍五入
    if (!scale) return value;

    let [_value, _scale] = [value, scale];

    if (
        !Object.prototype.toString.call(scale) !== '[object Number]' &&
        !isNaN(Number(scale))
    ) { _scale = Number(scale); }

    // 校验参数
    if (Object.prototype.toString.call(value) !== '[object String]') { _value = String(value); }

    //移除千分位
    // _value = _value.replace(/\,/gi, "");

    const re = /^(\-|\+)?(\d+)?\.?(\d+)?$/;

    if (_value && _value.length < 500 && !re.test(_value)) {
        console.warn('处理参数异常');
        return value;
    }

    // 分割value
    let [beforePoint, afterPoint] = _value.split('.');

    // 有小数位数
    if (afterPoint && afterPoint !== '') {
        // 判断小数位数与精度的关系
        if (afterPoint.length > _scale) {
            //_value = Number(_value);
            // 进行四舍五入操作
            //_value = Number(_value.toFixed(_scale + 1));//有进位
            _value = Number(_value.substring(0, beforePoint.length + 1 + _scale + 1));//有进位

            _value = _value * Math.pow(10, _scale);

            _value = Math.round(_value);

            _value = _value / Math.pow(10, _scale);
        }
    }

    return _value;
}

class NumberInput extends Component {
    constructor(props) {
        super(props);
        // 初始化 clear zero
        let { value, scale, maxlength } = this.props;
        value = this.commafy(this.checkLength(this.formatDot(this.removeThousands(value), scale), maxlength));
        if (value && String(scale)) {
            // 如果数据有小数点尝试四舍五入
            if (String(value).includes('.')) {
                value = ncRounding(value, scale);
            } else {
                // // 如果没有小数点就尝试进行补零
                // value = this.addZero(value, scale);
            }
            value = this.commafy(this.addZero(value, scale)); // 有没有 小数点  都需要补零 by bbqin
        }
        this.state = {
            value: value ? String(value) : '',
            verify: props.verify,
            reg: new RegExp('^[-|0-9]+(\\.[0-9]{0,' + props.scale + '})?$'),
            // 多语
            LangData: null,
            json: {},
            style: { textAlign: 'right' },
        };
        this.formatDocVO = getDataFormatFromCache();
        this.isFocus = false;
        this.onFocus = false;
    }

    componentWillReceiveProps(nextProps) {
        let { value, scale, maxlength = Infinity, noDataFormat = false } = nextProps;
        let style = { textAlign: 'right' };
        if (String(value).indexOf('-') !== -1 && this.formatDocVO.fm.nfm.negativeFormat.red && !noDataFormat) {
            style.color = 'red';
        }
        // 如果数据有小数点尝试四舍五入
        if (String(value).includes('.')) {
            value = ncRounding(value, scale);
        } else {
            // 如果没有小数点就尝试进行补零
            // value = this.addZero(value, scale);
        }
        value = this.addZero(value, scale);
        // if (value) value = this.commafy(value);
        // value = this.commafy(this.addZero(value, scale)); // 有没有 小数点  都需要补零 by bbqin

        if (!this.onFocus) {
            value = this.commafy(
                this.checkLength(
                    this.formatDot(this.removeThousands(value), scale),
                    maxlength,
                ),
            );
        }

        // if (this.isFocus) {
        //     value = this.commafy(
        //         this.checkLength(
        //             this.formatDot(this.removeThousands(value), scale),
        //             maxlength,
        //         ),
        //     );
        // }

        if (!this.isFocus) {
            if (value && scale) {
                // 如果数据有小数点尝试四舍五入
                if (String(value).includes('.')) {
                    value = ncRounding(this.removeThousands(value), scale);
                } else {
                    // 如果没有小数点就尝试进行补零
                    // value = this.addZero(value, scale);
                }

                value = this.addZero(value, scale);
                //获得焦点时不去执行添加千分位的操作
                if (this.onFocus !== true) {
                    value = this.commafy(value); // 有没有 小数点  都需要补零 by bbqin
                }
            }
            if (this.onFocus === true) {
                delete style.color;
            }
            // console.log('componentWillReceiveProps', value);
            this.setState({
                value,
                style,
                verify: nextProps.verify,
                reg: new RegExp('^[-|0-9]+(\\.[0-9]{0,' + nextProps.scale + '})?$'),
            }, () => {
                // if(nextProps.formNumber){
                //     // 把处理后的值 通知父组件
                //     value = this.removeThousands(value)
                //     // value 一样不进行处理
                //     if(String(this.removeThousands(this.props.value)) !== String(value)){
                //         nextProps.onChange && nextProps.onChange(value)
                //     }
                //     // nextProps.onBlur && nextProps.onBlur(value)
                // }
            });
        }
    }

    componentWillMount() {
        // 初始化调用getPlatformLang方法获取多语
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData }, () => {
                //  在这里进行之前组件willMount的操作，比如加载缓存之类的
            });
        };
        getMultiLang({ moduleId: 'base_ncnumber', callback }); // moduleId为所需加载json文件夹名称前缀
        this.numberDom = null;
    }

    componentDidMount() {
        let { scale, value, noDataFormat = false, renderInTable } = this.props;
        value = value + ''; //确保value是string类型
        let style = { textAlign: 'right' };
        if (String(value).indexOf('-') !== -1 && this.formatDocVO.fm.nfm.negativeFormat.red && !noDataFormat) {
            style.color = 'red';
        }
        // 初始化整数补零
        if (value && scale) {
            // 如果数据有小数点尝试四舍五入
            if (String(value).includes('.')) {
                value = ncRounding(value, scale);
            } else {
                // 如果没有小数点就尝试进行补零
                // value = this.addZero(value, scale);
            }
            value = this.addZero(value, scale);// 有没有 小数点  都需要补零 by bbqin

            // 先修复表格里面的情况，如果表单里也有问题，可以找我一起讨论下
            if (!this.onFocus || !renderInTable) {
                if (value) value = this.commafy(value);
            }
            // console.log('componentDidMount', value);
            this.setState({
                value,
                style,
            });
        }
    }

    handleFocus = e => {
        this.onFocus = true;
        let { scale, value } = this.state;
        if (!this.isFocus) {
            // 进行补零处理
            if (value && !String(value).includes('.') && scale) {

            }
        }
        value = this.addZero(value, scale);
        value = this.removeThousands(value, scale);

        if (isFunction(this.props.onFocus)) {
            this.props.onFocus(e);
        }
        // console.log('handleFocus', value);
        this.setState({ value, style: { textAlign: 'right' } }, () => {
            let inputDom = this.numberDom.querySelector('input');
            // console.log(inputDom);
            this.mouseDown !== true &&
                inputDom &&
                NEED_SELECTION_ITEMS.includes(this.props.itemtype) &&
                this.executeSelection(inputDom);
        });

    };

    executeSelection = inputDom => {
        let length = inputDom.value.length;
        inputDom.setSelectionRange(0, length);
    };

    // 控制光标位置
    setCursorPosition = (elem, index) => {
        var val = elem.value;
        var len = val.length;
        index--;
        // 超过文本长度直接返回
        if (len < index) return;
        setTimeout(function () {
            elem.focus();
            if (elem.setSelectionRange) {
                // 标准浏览器
                elem.setSelectionRange(index, index);
            } else {
                // IE9- 这个里面有问题在看
                var range = elem.createTextRange();
                range.moveStart('character', -len);
                range.moveEnd('character', -len);
                range.moveStart('character', index);
                range.moveEnd('character', 0);
                range.select();
            }
        }, 10);
    };

    handleChange = (newValue, e) => {
        // wangyang start  光标控制
        this.isFocus = true;
        // const re = /^(\-|\+)?(\d+)+\.?(\d+)?$/;
        // 解决number类型组件粘贴字符型数据粘贴失败的问题
        newValue = this.removeThousands(newValue)
        if (/\s/.test(newValue)) {
            this.isFocus = false;
        }

        if (/=/.test(newValue)) {
            this.isFocus = false;
        }

        newValue = newValue.trim();
        //修改正则 修复del不能删除问题
        const re = /^(\-|\+)?(\d+)?\.?(\d+)?$/;
        if (newValue.length != 0 && newValue.length < 500 && !re.test(newValue) && newValue !== '-') {
            // 当newValue === '-' 时 前面的校验不通过  !re.test(newValue) 为true 会导致-号无法删除  --bbqin
            this.setCursorPosition(e.target, e.target.selectionStart);
            return;
        }
        // 过滤逗号
        newValue = newValue.replace(/,*/g, '');
        // end wangyang  光标控制
        // start wanglong sacle maxlength
        let flag = true,
            { value, reg, verify } = this.state;
        let { onChange, scale = 0, maxlength } = this.props;
        // scale maxlength 移除千分位
        scale = Number(scale) > 0 ? Number(scale) : 0;
        maxlength = Number(maxlength) > 0 ? Number(maxlength) : Infinity;
        newValue = this.removeThousands(newValue);
        let intValue = newValue.split('.')[0];
        let scaleValueLength = newValue.split('.')[1]
            ? newValue.split('.')[1].length
            : 0;
        let intValueLength = maxlength - (scale != 0 ? scale + 1 : 0);
        if (intValue.length <= intValueLength && scaleValueLength <= scale) {
            newValue = this.formatDot(newValue, scale);
            if (typeof onChange === 'function') {
                onChange(newValue, e);
            }
            // console.log('handleChange', value);
            this.setState({
                value: newValue,
                verify,
            });
        } else {
            // sacle 不提示
            if (scaleValueLength > scale) {
                return;
            }

            let title = this.state.json['base-ncnumber-0001'];
            let tip = this.state.json['base-ncnumber-0002'];
            toast({
                mark: 'number_toast',
                color: 'danger',
                title,
                content: `${tip}:${maxlength}`,
            });
            // e.target.blur();
        }
    };

    //校验数值是否在合法区间内
    checkNumberRange = value => {
        const { max, min } = this.props;
        if (max || max == 0) {
            if (Number(value) > Number(max)) {
                return false;
            }
        }
        if (min || min == 0) {
            if (Number(value) < Number(min)) {
                return false;
            }
        }
        return true;
    };

    handleBlur = (newValue, e) => {
        let numberValue = this.props.value;
        let style = { textAlign: 'right' };
        if (String(numberValue).indexOf('-') !== -1 && this.formatDocVO.fm.nfm.negativeFormat.red) {
            style.color = 'red';
        }
        let originValue = newValue;
        this.isFocus = false;
        this.onFocus = false;
        this.mouseDown = false;
        // 阻止了Item的blur事件
        // e.stopPropagation();
        let { value, reg, verify } = this.state;
        const {
            onChange,
            scale,
            isrequired,
            onBlur,
            maxlength,
            max,
            min,
        } = this.props;
        newValue = this.removeThousands(newValue || '');
        newValue.replace('。', '.');

        // 如果value值不为空，就不进行去零处理
        if (newValue != '') {
            let [_integer, _decimal] = newValue.split('.');
            _integer = _integer.replace(/^0*/, '');
            _integer = _integer ? _integer : '0';
            _decimal = _decimal || "";
            newValue = _integer + '.' + _decimal;
        }

        // 整数
        if (!(Number(scale) > 0)) {
            newValue = newValue.split('.')[0];
        }

        // 整数部分
        let integerNumString = newValue.split('.')[0] + '';

        // ------- 修复最大值最小值
        if (originValue || originValue == '0') {
            if (max || max == 0) {
                if (Number(newValue) > Number(max) || integerNumString.length > 20) {
                    if (min || min == 0) {
                        let description = this.state.json['base-ncnumber-0003'];
                        toast({
                            color: 'warning',
                            content: `${description}[${min},${max}]`,
                            mark: 'base_number_maxmin',
                        });
                    } else {
                        let descriptionMax = this.state.json['base-ncnumber-0004'];
                        toast({
                            color: 'warning',
                            content: `${descriptionMax}${max}`,
                            mark: 'base_number_maxmin',
                        });
                    }
                    // console.log('handleBlur', value);
                    //清空number值
                    this.setState({
                        value: '',
                        style,
                    });
                    //清空父组件(表单或表格值)
                    if (typeof onChange === 'function') {
                        onChange('');
                    }
                    if (typeof onBlur === 'function') {
                        onBlur('');
                    }
                    return;
                    //newValue = max;
                }
            }
            if (min || min == 0) {
                if (Number(newValue) < Number(min)) {
                    if (max || max == 0) {
                        let description = this.state.json['base-ncnumber-0003'];
                        toast({
                            color: 'warning',
                            content: `${description}[${min},${max}]`,
                            mark: 'base_number_maxmin',
                        });
                    } else {
                        let descriptionMin = this.state.json['base-ncnumber-0005'];
                        toast({
                            color: 'warning',
                            content: `${descriptionMin}${min}`,
                            mark: 'base_number_maxmin',
                        });
                    }
                    // console.log('handleBlur', value);
                    //清空number值
                    this.setState({
                        value: '',
                        style: style,
                    });
                    //清空父组件(表单或表格值)
                    if (typeof onChange === 'function') {
                        onChange('');
                    }
                    if (typeof onBlur === 'function') {
                        onBlur('');
                    }
                    return;
                    //newValue = min;
                }
            }
        }

        if (scale && Number(scale) > 0) {
            newValue = this.addZero(newValue, scale);
        }
        // ------- 修复最大值最小值

        // 原来判断  if (reg.test(newValue) || newValue === "")
        if (reg.test(newValue)) {
            if (this.checkNumberRange(newValue)) {
                verify = true;
                value = this.addZero(newValue, scale);
            } else {
                value = '';
                verify = false;
            }
        } else {
            verify = false;
        }

        if (isrequired && newValue == '') {
            verify = false;
        }

        if (typeof onChange === 'function') {
            onChange(value);
        }

        if (typeof onBlur === 'function') {
            onBlur(value);
        }

        value = this.commafy(
            this.checkLength(
                this.formatDot(this.removeThousands(value), scale),
                maxlength,
            ),
        );
        // console.log('handleBlur', value);
        this.setState({
            value,
            verify,
            style: style,
        });
    };

    // 补0
    addZero(num, scale) {
        num = String(num);
        num = this.removeThousands(num);
        if (isNaN(Number(num)) || !num) {
            return null;
        }

        if (scale > 0) {
            let start = num.split('.')[0];
            let end = num.split('.')[1];
            if (!end) {
                end = '';
            }
            let len = end.length;
            if (len < scale) {
                end = end.padEnd(scale, '0');
            }
            return start + '.' + end;
        } else {
            return num;
        }
    }

    //移除千分位
    removeThousands(val) {
        if (val === null || val === undefined) return '';
        return String(val) ? String(val).replace(/\,/gi, '') : '';
    }

    //数字转换成千分位 格式
    commafy(num) {
        let pointIndex,
            intPart,
            pointPart;
        if (num === '-') {
            return '-';
        }
        if (isNaN(num)) {
            return '';
        }

        num = num + '';
        if (num.length < 500 && /^.*\..*$/.test(num)) {
            pointIndex = num.lastIndexOf('.');
            intPart = num.substring(0, pointIndex);
            pointPart = num.substring(pointIndex + 1, num.length);
            intPart = intPart + '';
            let re = /(-?\d+)(\d{3})/;
            while (intPart.length < 500 && re.test(intPart)) {
                intPart = intPart.replace(re, '$1,$2');
            }
            num = intPart + '.' + pointPart;
        } else {
            num = num + '';
            let re = /(-?\d+)(\d{3})/;
            while (num.length < 500 && re.test(num)) {
                num = num.replace(re, '$1,$2');
            }
        }
        return num;
    }

    // 精度处理
    formatDot(value, scale = 6) {
        let formatVal,
            dotSplit,
            val;
        val = (value || 0).toString();
        dotSplit = val.split('.');
        if (dotSplit.length > 2 || !value) {
            return value;
        }
        if (val.indexOf('.') > -1) {
            if (scale == 0) {
                formatVal = dotSplit[0];
            } else {
                // 向下取整模式
                formatVal = val.substring(0, val.indexOf('.') + scale + 1);
            }
        } else {
            formatVal = val;
        }

        return formatVal;
    }

    checkLength(value, maxlength) {
        if (value) {
            if (value.length <= maxlength || maxlength === undefined) {
                return value;
            } else {
                return value.substring(value.length - maxlength, value.length);
            }
        } else {
            return value;
        }
    }

    render() {
        let { suffix, fieldid, scale, noDataFormat = false, ...others } = this.props;
        let { value, verify, style } = this.state,
            errorMsg = null,
            errorBorder = '';

        if (!this.onFocus && !noDataFormat) {
            // console.log('format', value);
            // xiquanquan
            value = formatNumber(value);
        }
        //校验信息的控制
        if (!verify) {
            errorMsg = (
                <span className="input-error-message">{this.state.json['base-ncnumber-0006'] || '请输入合法的数据！'}</span>
            );
            errorBorder = 'error-border';
        }
        // console.log('render', value);
        //页面状态区分
        return (
            <div
                onMouseDown={() => {
                    this.mouseDown = true;
                }}
                ref={numberDom => { this.numberDom = numberDom }}
            >
                <Calculator
                    // 用传下来的value 没有格式
                    value={others.value}
                    calculateHandle={value => {
                        scale = Number(scale) > 0 ? Number(scale) : 0;
                        if (value && value.includes('.')) {
                            value = Big(value || "0").round(scale).toString(); 
                            //  String(ncRounding(value, scale));
                        }
                        // TODO event 对象的整理
                        this.handleChange.call(this, value, { target: this.numberDom })
                    }}
                >
                    <FormControl
                        fieldid={getSysFieldid(fieldid)}
                        className="number-formcontrol"
                        style={style}
                        autoComplete="off"
                        {...others}
                        value={value}
                        onChange={this.handleChange.bind(this)}
                        onBlur={(value, e) => this.handleBlur.call(this, value, e)}
                        onFocus={this.handleFocus}
                        maxlength={undefined}
                    />
                </Calculator>
                {suffix && <span style={{ lineHeight: '30px' }}>{suffix}</span>}
            </div>
        );
    }
}

NumberInput.propTypes = propTypes;
NumberInput.defaultProps = defaultProps;

export default NumberInput;
